document.addEventListener('submit', function(event) {
  const form = event.target;
  if (!form.matches('.product-card-form')) return;

  // Keep the normal Shopify form behavior if JavaScript is unavailable or a request fails.
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const initialLabel = button ? button.textContent : '';
  if (button) {
    button.disabled = true;
    button.textContent = 'Se adaugă...';
  }

  fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
  })
    .then(function(response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    })
    .then(function() {
      if (button) button.textContent = 'Adăugat ✓';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(function() {
        if (button) {
          button.disabled = false;
          button.textContent = initialLabel;
        }
      }, 1300);
    })
    .catch(function() {
      form.submit();
    });
});
